import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import UploadPage from "./pages/Upload";
import VideoDetail from "./pages/VideoDetail";
import TryVideoCreator from "./pages/TryVideoCreator";
import TryMusicCreator from "./pages/TryMusicCreator";
import BetCrypto from "./pages/BetCrypto";
import BuyCredits from "./pages/BuyCredits";
import Duel from "./pages/Duel";
import Poker from "./pages/Poker";
import Wastes from "./pages/Wastes";
import Cashout from "./pages/Cashout";
import Transfer from "./pages/Transfer";
import Profile from "./pages/Profile";
import Kyc from "./pages/Kyc";
import PokerTournaments from "./pages/PokerTournaments";
import PokerTournamentTable from "./pages/PokerTournamentTable";
import PokerLeaderboard from "./pages/PokerLeaderboard";
import BetMarkets from "./pages/BetMarkets";
import Marketplace from "./pages/Marketplace";

export default function App() {
    return (
        <div className="App min-h-screen">
            <BrowserRouter>
                <AuthProvider>
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route
                                path="/upload"
                                element={
                                    <ProtectedRoute>
                                        <UploadPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/video/:id" element={<VideoDetail />} />
                            <Route path="/try-video-creator" element={<TryVideoCreator />} />
                            <Route path="/try-music-creator" element={<TryMusicCreator />} />
                            <Route path="/bet-crypto" element={<BetCrypto />} />
                            <Route path="/buy-credits" element={<BuyCredits />} />
                            <Route path="/duel" element={<Duel />} />
                            <Route path="/poker" element={<Poker />} />
                            <Route path="/wastes" element={<Wastes />} />
                            <Route path="/cashout" element={<Cashout />} />
                            <Route
                                path="/transfer"
                                element={
                                    <ProtectedRoute>
                                        <Transfer />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/u/:username" element={<Profile />} />
                            <Route path="/kyc" element={<Kyc />} />
                            <Route path="/poker/tournaments" element={<PokerTournaments />} />
                            <Route path="/poker/tournament/:tid" element={<PokerTournamentTable />} />
                            <Route path="/poker/leaderboard" element={<PokerLeaderboard />} />
                            <Route path="/bet-markets" element={<BetMarkets />} />
                            <Route path="/marketplace" element={<Marketplace />} />
                        </Routes>
                    </main>
                    <footer className="border-t-[3px] border-ink bg-ink text-white mt-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-white border-[3px] border-white rounded-xl overflow-hidden">
                                    <img src="/endfb-logo.png" alt="Endfb" className="w-full h-full object-cover" />
                                </div>
                                <p className="font-heading font-black text-2xl tracking-tighter">End<span className="text-vibrantorange">fb</span></p>
                            </div>
                            <p className="font-body text-sm text-white/60">Loud videos. Bold creators. Real talk.</p>
                        </div>
                    </footer>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
